import { computed, observable } from 'mobx';
import { CXBaseBlock } from '~/components/ClientExperience/OneFlow/models/cx-base-block.model';
import type { CXScheduleContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-schedule-container-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { IScheduleSessionBlockStyles } from '~/types/block-styles.types';
import { IScheduleSessionBlockResponse } from '~/types/server.types';

export class CXScheduleSessionBlock extends CXBaseBlock {
    type: 'schedule_session_block';
    @observable styles: IScheduleSessionBlockStyles;

    constructor(
        block: IScheduleSessionBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }

    @computed
    get scheduleContainerBlock(): CXScheduleContainerBlock {
        return this.parent as CXScheduleContainerBlock;
    }
}
